export default "__VITE_ASSET__y6TuN0w5__"